import RequestState from 'Enums/RequestState'
import {
  chargePointLogFilter,
  chargePointTransactionFilter,
  chargePointStatisticsFilter,
  chargingSessionLogsFilter,
} from 'Constants/Filters'
import IFFilterType from 'Enums/IFFilterType'

export const INITIAL_STATE = {
  chargePoints: [],
  chargePointTransactions: [],
  chargePointLogs: [],
  bufferedChargePointLogs: [],
  chargePointLogsFirstItemIndex: 1000000,
  chargePointTariffs: [],
  chargePointPrivacySchedule: [],
  chargePointConfigs: {},
  chargePointUploadDiagnostics: [],
  chargePointAccessGroups: [],
  chargePointConfigsLastUpdated: undefined,
  fetchChargePointListRequestState: RequestState.UNINITIALIZED,
  fetchChargePointRequestState: RequestState.UNINITIALIZED,
  updateChargePointRequestState: RequestState.UNINITIALIZED,
  moveChargePointRequestState: RequestState.UNINITIALIZED,
  fetchChargePointLogListRequestState: RequestState.UNINITIALIZED,
  fetchChargePointTransactionListRequestState: RequestState.UNINITIALIZED,
  fetchChargePointConfigListRequestState: RequestState.UNINITIALIZED,
  fetchChargePointTariffsRequestState: RequestState.UNINITIALIZED,
  fetchChargePointPrivacyScheduleRequestState: RequestState.UNINITIALIZED,
  updateChargePointConfigRequestState: RequestState.UNINITIALIZED,
  deleteChargePointRequestState: RequestState.UNINITIALIZED,
  deleteChargePointTariffsRequestState: RequestState.UNINITIALIZED,
  deleteChargePointPrivacyRulesRequestState: RequestState.UNINITIALIZED,
  addChargePointTariffsRequestState: RequestState.UNINITIALIZED,
  addChargePointPrivacyRulesRequestState: RequestState.UNINITIALIZED,
  resetChargePointRequestState: RequestState.UNINITIALIZED,
  addChargePointRequestState: RequestState.UNINITIALIZED,
  deleteMovedChargePointRequestState: RequestState.UNINITIALIZED,
  clearChargePointCacheRequestState: RequestState.UNINITIALIZED,
  changeChargePointAvailabilityRequestState: RequestState.UNINITIALIZED,
  updateChargePointFirmwareRequestState: RequestState.UNINITIALIZED,
  fetchChargePointUploadDiagnosticsRequestState: RequestState.UNINITIALIZED,
  requestChargePointUploadDiagnosticsRequestState: RequestState.UNINITIALIZED,
  diagnosticsStatusNotificationRequestState: RequestState.UNINITIALIZED,
  fetchChargePointAccessGroupsRequestState: RequestState.UNINITIALIZED,
  deleteChargePointAccessGroupsBulkRequestState: RequestState.UNINITIALIZED,
  addChargePointAccessGroupsBulkRequestState: RequestState.UNINITIALIZED,
  selectedIndex: 0,
  chargePointLogPaginationOffset: 0,
  chargePointTransactionPaginationOffset: 0,
  chargePointFilterText: '',
  chargePointLogFilter: chargePointLogFilter,
  chargePointTransactionFilter: chargePointTransactionFilter,
  chargePointFirmwareUploadProgress: 0,
  isChargePointLogsLive: true,
  chargePointUptimeData: {
    uptimeGraphSeries: [
      { name: 'Online', data: [] },
      { name: 'Offline', data: [] },
      { name: 'Unstable', data: [] },
    ],
    uptimePercentages: { online: 0, offline: 0, unstable: 0 },
    isEmpty: true,
  },
  chargePointStatisticsFilter: chargePointStatisticsFilter,
  fetchChargePointUptimeStatisticsRequestState: RequestState.UNINITIALIZED,
  connectorsUtilizationData: {
    utilizationGraphSeries: [
      {
        name: 'Available',
        data: [],
      },
      {
        name: 'Charging',
        data: [],
      },
      {
        name: 'Occupied',
        data: [],
      },
      {
        name: 'Unavailable',
        data: [],
      },
      {
        name: 'Faulted',
        data: [],
      },
    ],
    utilizationPercentages: {
      available: 0,
      charging: 0,
      occupied: 0,
      unavailable: 0,
      faulted: 0,
    },
    isEmpty: true,
  },
  fetchConnectorsUtilizationRequestState: RequestState.UNINITIALIZED,
  fetchChargePointSubscribedAlertsRequestState: RequestState.UNINITIALIZED,
  subscribedAlerts: [],
  alerts: [],
  chargingProfiles: [],
  compositeSchedule: {},
  fetchChargePointAlertsRequestState: RequestState.UNINITIALIZED,
  updateChargePointAlertsRequestState: RequestState.UNINITIALIZED,
  chargePointLocalList: [],
  fetchChargePointLocalListRequestState: RequestState.UNINITIALIZED,
  updateChargePointLocalListRequestState: RequestState.UNINITIALIZED,
  fetchChargePointChargingProfilesRequestState: RequestState.UNINITIALIZED,
  fetchChargePointCompositeScheduleRequestState: RequestState.UNINITIALIZED,
  clearChargePointChargingProfileRequestState: RequestState.UNINITIALIZED,
  setChargePointChargingProfileRequestState: RequestState.UNINITIALIZED,
  createChargePointChargingProfileRequestState: RequestState.UNINITIALIZED,
  connectorTypes: {},
  fetchConnectorTypesRequestState: RequestState.UNINITIALIZED,

  chargingSessionLogs: [],
  fetchChargingSessionLogsRequestState: RequestState.UNINITIALIZED,
  chargingSessionLogsPaginationOffset: 0,
  chargingSessionLogsFirstItemIndex: 1000000,
  bufferedChargingSessionLogs: [],
  chargingSessionLogsFilter: chargingSessionLogsFilter,

  chargingSessionDetails: [],
  fetchChargingSessionDetailsRequestState: RequestState.UNINITIALIZED,

  chargingSessionEvents: [],
  fetchChargingSessionEventsRequestState: RequestState.UNINITIALIZED,

  isChargingAnalyticsLive: false,
  reverseTransactionRequestState: RequestState.UNINITIALIZED,

  blockChargePointRequestState: RequestState.UNINITIALIZED,
}
